// ExclusiveRevisionTooltipHintHandler.js
import { connect } from 'react-redux';

import ExclusiveRevisionTooltipHintHandler from '../component/ExclusiveRevisionTooltipHintHandler.jsx';
import toggleModal from '../action/toggleModal.js';
import setShouldDisplayExclusiveRevisionTooltip from '../action/setShouldDisplayExclusiveRevisionTooltip.js';
import getOperationData from '../selector/getOperationData.js';

const mapStateToProps = state => {
  return {
    shouldDisplayExclusiveRevisionTooltip: getOperationData(
      state,
      ['liveStream'],
      'shouldDisplayExclusiveRevisionTooltip'
    ),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    markExclusiveRevisionTooltipSeen: () =>
      dispatch(
        setShouldDisplayExclusiveRevisionTooltip({
          shouldDisplayExclusiveRevisionTooltip: false,
        })
      ),
    openModal: () =>
      dispatch(
        toggleModal({ modalId: 'ExclusiveRevisionTooltips', isOpen: true })
      ),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExclusiveRevisionTooltipHintHandler);
